import type { ConfigType } from '@plone/registry';
// @ts-ignore
import cloneDeep from 'lodash/cloneDeep';

import TextWithBlocksEdit from '../components/Blocks/TextWithBlocks/Edit';
import TextWithBlocksView from '../components/Blocks/TextWithBlocks/View';
import { TextWithBlocksDataAdapter } from '../components/Blocks/TextWithBlocks/adapter';
import { TextWithBlocksSchema } from '../components/Blocks/TextWithBlocks/schema';
import textWithBlocksTemplates from '../components/Blocks/TextWithBlocks/templates';

import ClippedImageSchema from '../components/Blocks/ClippedImage/Schema';
import ClippedImageView from '../components/Blocks/ClippedImage/View';
import CallForProposalFormEdit from '../components/Blocks/CallForProposalForm/Edit';
import CallForProposalFormView from '../components/Blocks/CallForProposalForm/View';
import SponsorsShowcaseView from '../components/Blocks/SponsorsShowcase/View';
import SessionTemplate from '../components/Blocks/Listing/SessionTemplate';
import SpeakerTemplate from '../components/Blocks/Listing/SpeakerTemplate';

import imagesSVG from '@plone/volto/icons/images.svg';

// @ts-ignore
import gridSVG from '@plone/volto/icons/grid.svg';

export default function installBlocks(config: ConfigType) {
  // Clipped Image
  config.blocks.blocksConfig.clippedImage = {
    id: 'clippedImage', // this is the block id, it must match the id on the previous line
    title: 'Clipped Image',
    view: ClippedImageView,
    blockSchema: ClippedImageSchema,
    icon: imagesSVG,
    sidebarTab: 1,
    group: 'common',
  };

  // Text with Blocks
  config.blocks.blocksConfig.textWithBlocks = {
    id: 'textWithBlocks',
    title: 'Text with Blocks',
    icon: gridSVG,
    group: 'common',
    view: TextWithBlocksView,
    edit: TextWithBlocksEdit,
    blockSchema: TextWithBlocksSchema,
    dataAdapter: TextWithBlocksDataAdapter,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    templates: textWithBlocksTemplates,
    maxLength: 4,
    allowedBlocks: ['image', 'listing', 'slate', 'teaser', 'clippedImage'],
    blocksConfig: {
      ...cloneDeep(config.blocks.blocksConfig),
      clippedImage: config.blocks.blocksConfig.clippedImage,
    },
  };

  // Call for Proposals Form
  config.blocks.blocksConfig.cfpForm = {
    id: 'cfpForm',
    title: 'Call for Proposals Form',
    icon: imagesSVG,
    group: 'common',
    view: CallForProposalFormView,
    edit: CallForProposalFormEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Allow the "Clipped Image" block to appear in the "Grid Block"
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('clippedImage');
  config.blocks.blocksConfig.gridBlock.blocksConfig = {
    ...config.blocks.blocksConfig.gridBlock.blocksConfig,
    clippedImage: config.blocks.blocksConfig.clippedImage,
  };

  // Allow HTML block to appear in the "Grid Block"
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('html');

  if (config.blocks.blocksConfig.sponsorsShowcaseBlock) {
    config.blocks.blocksConfig.sponsorsShowcaseBlock = {
      ...config.blocks.blocksConfig.sponsorsShowcaseBlock,
      view: SponsorsShowcaseView,
    };
  }

  // Listing variations
  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    variations: [
      ...(config.blocks.blocksConfig.listing.variations || []),
      {
        id: 'session',
        title: 'Session',
        template: SessionTemplate,
        fullobjects: true,
      },
      {
        id: 'speaker',
        title: 'Speaker',
        template: SpeakerTemplate,
        fullobjects: true,
      },
    ],
  };

  return config;
}
